import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { CacheService, ITypeOrganizationalStructureBO } from '@mapfre-tech/amap3';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StructureOrganizativeTypeService {

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  className = 'StructureOrganizativeTypeService';

  getAllEOTypes(cache = true, cacheKey = "allEOTypes"): Observable<ITypeOrganizationalStructureBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeOrganizationalStructureBO[]>;
    } else {
      const observable = this.http.get<ITypeOrganizationalStructureBO[]>(environment.base_URL + "/types-organizational-structures").pipe(map((res) => {
        this.cacheService.updateCacheData(res, cacheKey);
        return res;
      }));
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }
}
